import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UsePermittedReportsProps<T> = {
  filters?: {
    page?: number;
    search?: string;
  };
  mapper?: (data: any) => T,
};

export const usePermittedReports = <T,>({
  filters: { search, page } = {},
  mapper = Mapper.default<T>(),
}: UsePermittedReportsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['permittedReports', search, page],
    queryFn: () => {
      return privateAxios.get(`/reports/entries/permitted_reports`, {
        params: {
          search,
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
